import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import {
  MsalAuthenticationTemplate,
  MsalProvider,
  useMsalAuthentication,
} from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { PageLayout } from "./ui-components/PageLayout";
import {
  loginLandingPageRequest
} from "./authConfig";
import { ErrorComponent } from "./ui-components/ErrorComponent";
import { ArcadisThemeProvider } from "./styles/arcadis";
import { GdprProvider } from "@arcadis/gdpr-react";
import "./i18n";
import { Loading } from "./ui-components/Loading";

const Home = lazy(() => import("./pages/Home"));
const ProtectedContentAdminApps = lazy(() => import("./pages/ProtectedContentAdminApps"));

const ProtectedContentAppEdit = lazy(
  () => import("./pages/ProtectedContentAppEdit")
);
const ProtectedDataForApp = lazy(() => import("./pages/ProtectedDataForApp"));
const ProtectedDomains = lazy(() => import("./pages/ProtectedDomains"));
const AdminViewApp = lazy(() => import("./pages/AdminViewApp"));

const LoginLoading = () => {
  return <Loading message="Authentication in progress..." />
}

interface AppProps {
  pca: PublicClientApplication;
}

const instrumentation_key = process.env.REACT_APP_INTRUMENTATION_KEY as string;
function App({ pca }: AppProps): JSX.Element {
  return (
    <Router>
      <GdprProvider instrumentationKey={instrumentation_key}>
        <ArcadisThemeProvider>
          <MsalProvider instance={pca}>
            <PageLayout>
              <Suspense fallback={<Loading />}>
                <MsalAuthenticationTemplate
                  interactionType={InteractionType.Redirect}
                  authenticationRequest={loginLandingPageRequest}
                  errorComponent={ErrorComponent}
                  loadingComponent={LoginLoading}
                >
                  <Pages />
                </MsalAuthenticationTemplate>
              </Suspense>
            </PageLayout>
          </MsalProvider>
        </ArcadisThemeProvider>
      </GdprProvider>
    </Router>
  );
}

function Pages() {
  const msalResult = useMsalAuthentication(
    InteractionType.Redirect,
    loginLandingPageRequest
  );

  return (
    <Routes>
      <Route path="/error" element={<ErrorComponent {...msalResult} />} />
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<ProtectedContentAdminApps />} />
      <Route path="/admin/create" element={<ProtectedContentAppEdit />} />
      <Route path="/admin/:id/edit" element={<ProtectedContentAppEdit />} />
      <Route path="/admin/:id/view" element={<AdminViewApp />} />
      {/* <Redirect exact from="/admin/:id" to="/admin/:id/roles" /> */}
      {/* <Route path="/admin/:id" render={() => <Redirect to="/admin/:id/roles" />} /> */}
      <Route path="/admin/:id/*" element={<ProtectedDataForApp />} />
      <Route path="/domains" element={<ProtectedDomains />} />
    </Routes>
  );
}
export default App;
